module.exports = __webpack_public_path__ + "img/Flag_of_Bosnia_and_Herzegovina.6797119c.svg";